<template>
  <div>
    <div id="application-table" class="application-block">
      <p class="title first-title"><i class="fal fa-receipt"></i> 상품 상세 정보</p>
      <div class="goods-info-table-wrap">
        <table class="table_row_pay">
          <colgroup><col width="200px;"><col></colgroup>
          <tbody>
          <tr>
            <th><p>상품</p></th>
            <td v-show="packageName">
              <span>
                하이웍스 <i class="fal fa-chevron-right mh-10"></i>
                {{packageName}}
              </span>
              <a v-if="changeGoodsLink" :href="changeGoodsLink"
                 target="_self" class="hw-pill-button bordered smaller ml-10">
                {{changeRule.display_name}}
              </a>
            </td>

          </tr>
          <tr>
            <th><p>상세</p></th>
            <td>
              <div>

                <GoodsDetailTable
                    :select-goods-id="selectGoodsId"
                    @change-select-goods="changeSelectGoods"
                />

              </div>
            </td>
          </tr>
          <tr>
            <th>
              <p>  이용  <span> 기간</span></p>
            </th>
            <td>
              <ul class="list_pay_table_sub">
                <li>
                  <div style="display: inline;">
                    <label class="lib-mr-20" v-for="termInfo in payTerms" :key="termInfo.term_volume">
                      <input type="radio"
                             name="pay_term"
                             class="lib-mr-5"
                             v-model="payTerm"
                             :value="termInfo.term_volume"/>
                      <span>{{termInfo.term_volume}} {{supplyTerms.term_unit_name}}</span>
                      <span v-if="termInfo.discount_rule && termInfo.discount_rule[0]">
                        ({{termInfo.discount_rule[0].display_value}} 할인)
                      </span>
                    </label>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th><p>만기일</p></th>
            <td><span>{{formattedExpireDate}}</span>  &nbsp;  <p class="info-text">실제 세팅 일자에 따라 만기일이 달라질 수 있습니다.</p></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import GoodsDetailTable from "@/components/step1/GoodsTable/GoodsDetailTable";

export default {
  name: "GoodsTable",
  components: {
    GoodsDetailTable
  },
  props:{
    selectGoodsId : {
      type : Number
    }
  },
  computed: {
    ...mapState({
      expireDate: state => state['order_info']['expireDate'],
    }),
    ...mapGetters({
      payTerms : 'goods_info/searchPayTerms',
      supplyTerms : 'goods_info/getSupplyTerms',
      packageName : 'goods_info/getPackageName',
      changeRule : 'goods_info/getChangeRule',
    }),
    payTerm: {
      get () {return this.$store.state.order_info.payTerm},
      set (payTerm) {this.$store.commit('order_info/setPayTerm', payTerm)}
    },
    formattedExpireDate(){
      if(!this.expireDate){
        return null
      }
      const year = this.expireDate.getFullYear()
      const month = this.expireDate.getMonth() + 1
      const date = this.expireDate.getDate()

      return year + "년 "+ month + "월 " + date +"일"
    },
    changeGoodsLink(){
      if(!this.changeRule){
        return null
      }
      if(!this.changeRule.id){
        return null
      }
      return location.origin + location.pathname + '?id=' + this.changeRule.id
    }
  },
  methods: {
    ...mapActions({
      setDomainInit: 'setDomainInit',
    }),
    changeSelectGoods(selectGoodsId){
      this.$emit('change-select-goods', selectGoodsId)
      this.setDomainInit()
    },
  }
}
</script>

<style scoped>

</style>